import { render } from "./ProductsChangePage.vue?vue&type=template&id=04149a10&scoped=true"
import script from "./ProductsChangePage.vue?vue&type=script&lang=js"
export * from "./ProductsChangePage.vue?vue&type=script&lang=js"

import "./ProductsChangePage.vue?vue&type=style&index=0&id=04149a10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04149a10"]])

export default __exports__